export default {"src":"/_next/static/media/ellipse-security.425ca706.svg","height":3,"width":429,"blurWidth":0,"blurHeight":0};